module.exports = __webpack_public_path__ + "static/media/gsg.66d93050.png";